import React from "react";
import Tabs from "./tabs.jsx"
import { FormattedMessage, injectIntl, defineMessages } from "react-intl";
import { IconArrowLeft, IconFileDefault, IconFileExcel, IconFileMusic, IconFilePdf, IconFileRar, IconFileTxt, IconFileVideo, IconFileWord, IconFileXml, IconFileZip, IconLinkDefault, IconNoMedia, IconSearch, IconStorageDefault } from '../../icons/svg';
import { SCREEN } from '../info-view-content.jsx';
import Helpers from "../../lib/helpers.js";
import { bytesToHumanSize } from "../../lib/strformat.js";
import YetAnotherLightbox from "./yet-image-lightbox.jsx";
import linkDefault from '../../img/link.png';
import { copyTextToClipboard } from '../../lib/utils.js';


const messages = defineMessages({
    mediaStorage: {
        id: "mediaStorage",
        defaultMessage: "Stored media",
        description: "Stored media",
    },
    noMediaFound: {
        id: "noMediaFound",
        defaultMessage: "No {mediaType}",
        description: "No {mediaType}",
    },
    mediaImage: {
        id: "mediaImage",
        defaultMessage: "Images",
        description: "Images",
    },
    mediaLink: {
        id: "mediaLink",
        defaultMessage: "Links",
        description: "Links",
    },
    mediaFile: {
        id: "mediaFile",
        defaultMessage: "Files",
        description: "Files",
    },
    today: {
        id: "today",
        defaultMessage: "Today",
        description: "Today",
    },
    yesterday: {
        id: "yesterday",
        defaultMessage: "Yesterday",
        description: "Yesterday",
    },
    time_at: {
        id: "time_at",
        defaultMessage: "at",
        description: "at",
    },
    copy_success: {
      id: 'copy_success',
      defaultMessage: 'Copied successfully',
      description: 'Copied successfully'
    }
});

class SharedStorage extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            showPopup: false,
            srcImg: '',
            media_link_selected: '',
            listImagesShow: [],
            media_id_selected: '',
            indexImage: 0
        };
        this.handleShowImage = this.handleShowImage.bind(this);
        this.handleCloseImage = this.handleCloseImage.bind(this);
        this.renderNoItemFound = this.renderNoItemFound.bind(this);
        this.handleShowMessage = this.handleShowMessage.bind(this);
        this.getMetadataLink = this.getMetadataLink.bind(this);
        this.getIconFile = this.getIconFile.bind(this);
        this.getMonthYearList = this.getMonthYearList.bind(this);
        this.getFormattedMonthYear = this.getFormattedMonthYear.bind(this);
        this.formatTime = this.formatTime.bind(this);
        this.formatTimestamp = this.formatTimestamp.bind(this);
    }

    handleShowImage(src,media_link,messageId,listImagesShow, indexImage) {
        this.setState({
            srcImg: src,
            showPopup: true,
            media_link_selected: media_link,
            media_id_selected: messageId,
            listImagesShow: listImagesShow,
            indexImage:indexImage
        });
    }

    handleCloseImage() {
        this.setState({
            srcImg: '',
            showPopup: false,
            media_link_selected: '',
            listImagesShow: [],
            media_id_selected: '',
            indexImage: 0
        });
    }

    renderNoItemFound = text => (
        <div style={{ textAlign: 'center', marginTop: 35 }}>
            <div className="noMedia"><IconStorageDefault></IconStorageDefault></div>
            <div style={{ marginTop: 5 }}>{text}</div>
        </div>
    )

    downloadAndOpenFile = (message) => {
        // Replace 'path/to/your/file.pdf' with the actual path to your file
        const filePath = Helpers.getDownloadURL(message.media_link)
        const fileName = message.name
        const mimetype = Helpers.getMimeType(fileName)

        const downloader = this.props.tinode.getLargeFileHelper();

        downloader.download(filePath, fileName, mimetype)
      };

    renderTabImage = () => {
        const { topic } = this.props
        const topicInfo = this.props.tinode.getTopicByName(topic)
        const { formatMessage } = this.props.intl;
        if (topicInfo.shareImage && topicInfo.shareImage.length > 0) {
            return (
                <div className="list-image">
                    {topicInfo.shareImage.filter(sharedImage => typeof sharedImage.media_link !== 'undefined').map((message, idx) => {                        
                        const url = Helpers.getDownloadURL(message.media_link)
                        return (
                            <div className="img" key={`shared_img_${message.messageId}_${idx}`}>
                                <img
                                    // id={`shared_img_${message.messageId}`}
                                    src={url}
                                    alt="shared_img"
                                    onClick={() => {
                                        this.handleShowImage(url,message.media_link,message.messageId,topicInfo.shareImage, idx);
                                    }}
                                />
                            </div>
                        )
                    })}
                </div>
            )
        }
        return this.renderNoItemFound(formatMessage(messages.noMediaFound, { mediaType: formatMessage(messages.mediaImage) }))
    }

    renderTabLink = () => {
        const { topic } = this.props
        const topicInfo = this.props.tinode.getTopicByName(topic)
        const listLinks = this.getMetadataLink(topicInfo.shareLink, topicInfo, this.props.tinode)
        const { formatMessage } = this.props.intl;
        if (listLinks && Array.isArray(listLinks) && listLinks.length > 0) {
            return (
                <div
                    id="group-shared-link"
                    className="link-info-container"
                >
                    {this.getMonthYearList(listLinks).map((month) => {
                        const currentDate = new Date();
                        const isCurrentMonth = this.getFormattedMonthYear(currentDate) === month.label;
                        return (
                            <div key={month.label} className="shared-file-container">
                                {!isCurrentMonth && 
                                <h3>{month.label}</h3>}
                                <ul style={{listStyle: "none"}}>
                                    {month.files.map((link, idx) => ( 

                                        <li key={idx}>
                                            <div className="link-info-element" onClick={(e) => { e.preventDefault(); this.handleShowMessage(link, topicInfo) }}>
                                                <div className="element-container">
                                                    <div className="link-info-left">
                                                        {link.imgUrl ? <img className="link-info-img" src={link.imgUrl}
                                                            alt="favicon"
                                                            onError={e => e.target.src = linkDefault}></img>
                                                            :
                                                            <IconLinkDefault></IconLinkDefault>
                                                        }
                                                    </div>
                                                    <div className="link-info-right">
                                                        <div className="link-info-title">{link.title}</div>
                                                        <div className="link-info-desc">{link.description}</div>
                                                        <div className="link-info-time">{this.formatTimestamp(Number(link.timesend))}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        );
                    })
                    }
                </div>
            )
        }
        return this.renderNoItemFound(formatMessage(messages.noMediaFound, { mediaType: formatMessage(messages.mediaLink) }))
    }

    getMetadataLink(shareLinks, topic, tinode) {
        let shareNewLinks = [];
        if (shareLinks && shareLinks.length > 0) {
            shareNewLinks = shareLinks.map(message => {
                let title = message.url;
                let description = message.url;
                let imgUrl = undefined;
                const isGetMetadata = true;
                if (message.messageId) {
                    const msg = topic.findMessageById(message.messageId);
                    if (msg && msg.previewLink) {
                        const previewLink = msg.previewLink
                        title = previewLink.item_name
                        description = previewLink.description
                        imgUrl = previewLink.img_url
                    }
                }
                return {
                    ...message,
                    title,
                    description,
                    imgUrl,
                    isGetMetadata
                }
            })
        }

        return shareNewLinks

        // // Cập nhật giao diện chat list
        // const sub = {
        //     topic: topic,
        //     public: topic.public,
        //     read: topic.read,
        //     recv: topic.recv,
        //     seq: topic.seq,
        //     touched: topic.touched,
        //     updated: topic.updated,
        //     shareLink: shareNewLinks,
        // };
        // const topicMe = tinode.getMeTopic();
        // topicMe._processMetaSubs([sub]);
        // console.log("END|", shareNewLinks)

    }

    // Hàm trả ảnh extension ứng với các loại file
    getIconFile = (filename) => {
        const extension = Helpers.getFileExtension(filename);
        switch (extension) {
            case 'txt':
                return <IconFileTxt></IconFileTxt>
            case 'doc':
            case 'docx':
                return <IconFileWord></IconFileWord>
            case 'xls':
            case 'xlsx':
                return <IconFileExcel></IconFileExcel>
            case 'pdf':
                return <IconFilePdf></IconFilePdf>
            case 'zip':
                return <IconFileZip></IconFileZip>
            case 'rar':
                return <IconFileRar></IconFileRar>
            case 'mov':
            case 'wav':
            case 'flac':
            case 'aac':
            case 'm4a':
            case 'mp3':
                return <IconFileMusic></IconFileMusic>
            case 'xml':
                return <IconFileXml></IconFileXml>
            case 'mp4':
            case 'avi':
            case 'flv':
            case 'wmv':
            case 'mkv':
            case 'webm':
            case 'ogg':
            case 'mpeg':
            case '3gp':
                return <IconFileVideo></IconFileVideo>
            case 'ppt':
            case 'pptx':
            case 'psd':           
            default:
                return <IconFileDefault></IconFileDefault>
        }
    }

    handleShowMessage(msg, topic) {
        const msgRoot = topic.findMessageById(msg.messageId);
        if (msgRoot) {
            // const seqId = msgRoot.seq

            // Đóng tab info-view-content
            // this.props.onCancel()

            // Scroll tới tin nhắn
            // const { _chatMessageRefs } = this.props.tinode
            // if (_chatMessageRefs.hasOwnProperty(seqId)) {
            //     const ref = _chatMessageRefs[seqId]
            //     ref.current.scrollIntoView({ block: "center", behavior: "smooth" })
            //     ref.current.classList.add('flash');
            //     setTimeout(_ => { ref.current.classList.remove('flash') }, 1000);
            // }

            const { formatMessage } = this.props.intl

            console.log(msg)
            copyTextToClipboard(msg.url)
            Helpers.showSuccessToasts(formatMessage(messages.copy_success));
        }
    }

    getFormattedMonthYear = (timestamp) => {
        return new Date(timestamp).toLocaleDateString('en-US', {
          year: 'numeric',
          month: '2-digit',
        });
      };

      getMonthYearList = (listSorts) => {
        const monthYearList = [];
    
        listSorts.forEach((file) => {
          const monthYear = this.getFormattedMonthYear(file.timesend);
    
          if (!monthYearList.includes(monthYear)) {
            monthYearList.push(monthYear);
          }
        });
    
        return monthYearList
          .sort((a, b) => new Date(b) - new Date(a))
          .map((monthYear) => ({
            label: monthYear,
            files: listSorts
              .filter(
                (file) => this.getFormattedMonthYear(file.timesend) === monthYear
              )
              .sort((a, b) => b.timesend - a.timesend),
          }));
      };

      formatTimestamp = (timestamp) => {
        const { formatMessage } = this.props.intl;
        const currentDate = new Date();
        const inputDate = new Date(timestamp);
      
        if (
          inputDate.getDate() === currentDate.getDate() &&
          inputDate.getMonth() === currentDate.getMonth() &&
          inputDate.getFullYear() === currentDate.getFullYear()
        ) {
          return `${formatMessage(messages.today)} ${formatMessage(messages.time_at)} ${this.formatTime(inputDate)}`;
        }
      
        const yesterday = new Date(currentDate);
        yesterday.setDate(currentDate.getDate() - 1);
      
        if (
          inputDate.getDate() === yesterday.getDate() &&
          inputDate.getMonth() === yesterday.getMonth() &&
          inputDate.getFullYear() === yesterday.getFullYear()
        ) {
          return `${formatMessage(messages.yesterday)} ${formatMessage(messages.time_at)} ${this.formatTime(inputDate)}`;
        }
      
        return `${this.formatDate(inputDate)} ${formatMessage(messages.time_at)} ${this.formatTime(inputDate)}`;
      }
      
      formatTime = (date) => {
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        return `${hours}:${minutes}`;
      }
      
      formatDate = (date) => {
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
      }

    renderTabFile = () => {
        const { topic } = this.props
        const topicInfo = this.props.tinode.getTopicByName(topic)
        const { formatMessage } = this.props.intl;
        if (topicInfo.shareFile && Array.isArray(topicInfo.shareFile) && topicInfo.shareFile.length > 0) {
            return (this.getMonthYearList(topicInfo.shareFile).map((month) => {
                const currentDate = new Date();
                const isCurrentMonth = this.getFormattedMonthYear(currentDate) === month.label;
                return (
                    <div key={month.label} className="shared-file-container">
                        {!isCurrentMonth && <h3>{month.label}</h3>}
                        <ul>
                            {month.files.map((file,idx) => (
                                <li key={`${file.name}_${idx}`} className="shared-file-element" onClick={() => this.downloadAndOpenFile(file)}>
                                    <div className="shared-file-left">
                                        <div className="shared-file-ext">{this.getIconFile(file.name)}</div>
                                    </div>
                                    <div className="shared-file-right">
                                        <div className="shared-file-name">{file.name}</div>
                                        <div className="shared-file-size">{bytesToHumanSize(Number(file.size))} • {this.formatTimestamp(Number(file.timesend))}</div>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                );
            })
            )
        }
        return this.renderNoItemFound(formatMessage(messages.noMediaFound, { mediaType: formatMessage(messages.mediaFile) }))
    }

    render() {
        const { formatMessage } = this.props.intl;
        return (
            <div className="stored-media-container info-image">
                <div className="header storage-header" onClick={() => this.props.handleSetScreen(SCREEN.INFO)}>
                    <div className="icon"><IconArrowLeft /></div>
                    <div className="name">{formatMessage(messages.mediaStorage)}</div>
                    <div className="icon-search" style={{display: "none"}}><IconSearch></IconSearch></div>
                </div>

                <div className="tabs">
                    <Tabs>
                        <Tab label={formatMessage(messages.mediaImage)}>
                            <div className="info-image">
                                {this.renderTabImage()}
                            </div>
                        </Tab>
                        <Tab label={formatMessage(messages.mediaLink)}>
                            <div>
                                {this.renderTabLink()}
                            </div>
                        </Tab>
                        <Tab label={formatMessage(messages.mediaFile)}>
                            <div>
                               {this.renderTabFile()}
                            </div>
                        </Tab>
                    </Tabs>
                </div>
                {this.state.showPopup &&
                <YetAnotherLightbox     
                showModalImage = {this.state.showPopup}
                listImagesMessage={this.state.listImagesShow}
                indexImage={this.state.indexImage}
                setStateIndexImage={(index, showPopup) => this.setState({indexImage: index, showPopup})}
                />
                }
            </div>
        );
    }
}

const Tab = props => {
    return (
        <React.Fragment>
            {props.children}
        </React.Fragment>
    )
}

export default injectIntl(SharedStorage);